import templateUrl from "./auto-email-notifications.html";

export const autoEmailNotificationsUrlComponent = {
  templateUrl,
  bindings: {
    details: "<",
  },

  controller: class AutoEmailNotificationsUrlComponent {
    constructor($state, SettingsService, toastr) {
      "ngInject";
      this.$state = $state;
      this.toastr = toastr;
      this.SettingsService = SettingsService;
      this.plainDescription = "";
    }

    $onInit() {
      if (!this.details.values) {
        this.details.values = {};
      }
      this.disableButtons = false;
    }

    onSubmit() {
      if (this.plainDescription.trim()) {
        this.disableButtons = true;
        this.SettingsService.updateSettingDetails(this.details.name, {
          value: this.details.values,
        })
          .then((_) => {
            this.disableButtons = false;
            this.toastr.success("Settings updated successfully");
          })
          .catch((errmsg) => {
            this.disableButtons = false;
            this.toastr.error(errmsg);
          });
      }
    }

    onCancel() {
      this.$state.go("settings");
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/settings/components/auto-email-notifications/auto-email-notifications.component.js